import * as yup from "yup";

export const addPaymentTransactionManualSchema = yup.object().shape({
  transactionNo: yup.string().required("Transaction number is required"),
  amount: yup
    .number("Please input amount")
    .min(0, "The minimum amount is 0")
    .typeError("Amount is required")
    .required("Amount is required"),
  date: yup
    .date()
    .max(new Date(), "Future dates are not allowed")
    .required("Date is required"),
  caseId: yup.string().required("Case Id is required"),
  caseProgressId: yup.string().required("Case Progress Id is required"),
});
